import localforage from 'localforage'

export const storageDb = localforage.createInstance({
  driver: [localforage.INDEXEDDB, localforage.WEBSQL, localforage.LOCALSTORAGE],
  size: 1e8, // Size of database, in bytes. WebSQL-only for now.
  name: 'flpro_db',
  storeName: 'flpro_persist',
  version: 1.0,
})
